<script setup lang="ts">
import { defineProps, computed } from 'vue'

const props = defineProps({
  height: {
    type: Number,
    default: 38
  },
  color: {
    type: String,
    default: 'white'
  },
  maskColor: {
    type: String,
    default: '#333333'
  }
})

const height = computed(() => props.height)
const color = computed(() => props.color)
const maskColor = computed(() => props.maskColor)
const width = computed(() => height.value * 80/ 38)
</script>

<template>
  <svg :width="width" :height="height" viewBox="0 0 80 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_8625_9943)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4744 1.08171L0 26.4713H9.11835L15.0102 12.1574L10.4744 1.08171ZM46.714 1.08171L36.2396 26.4713H45.3579L51.2499 12.1574L46.714 1.08171ZM28.7111 12.1105L24.1286 1.08171L19.5928 12.1105L13.6541 26.4713L18.2367 37.5L24.1286 23.1861L25.4846 26.4713H34.603L28.7111 12.1105ZM49.8938 26.4713H57.1884L53.5411 17.6483L49.8938 26.4713ZM65.6054 13.753C65.6054 11.1719 67.7098 9.05995 70.2817 9.05995C70.6559 9.05995 70.9831 9.10686 71.3104 9.20075L74.5369 1.3633C73.1808 0.893986 71.7779 0.659332 70.2347 0.659332C62.9868 0.659332 57.1417 6.52568 57.1417 13.8C57.1417 19.0093 60.1344 23.5147 64.5299 25.6265L67.7567 17.789C66.4939 16.8974 65.6054 15.4425 65.6054 13.753ZM72.3855 17.6013L68.7385 26.4713H76.0331L72.3855 17.6013Z" :fill="color"/>
    </g>
    <defs>
      <clipPath id="clip0_8625_9943">
        <rect :width="width" :height="height" :fill="color" transform="translate(0 0.5)"/>
      </clipPath>
    </defs>
  </svg>
</template>

<style scoped lang="less">

</style>
